export const acceptVideoTypes = [
  '.avi',
  '.mpg',
  '.mpeg',
  '.3gp',
  '.mov',
  '.mp4',
  '.flv',
  '.f4v',
  '.m4v',
  '.m2t',
  '.mts',
  '.rmvb',
  '.vob',
  '.mkv',
];
export const shopeeVideoDurationMin = 1;
export const shopeeVideoDurationMax = 180;
export const lazadaVideoDurationMin = 0;
export const lazadaVideoDurationMax = 180;
export const facebookVideoDurationMax = 75;

export const lazadaVideoMinWidth = 480;

export const shopeeVideoSizeLimit = 30 * 1024 * 1024;
export const lazadaVideoSizeLimit = 100 * 1024 * 1024;
export const whatsAppVideoSizeLimit = 100 * 1024 * 1024;
export const facebookVideoSizeLimit = 25 * 1024 * 1024;
export const tiktokVideoSizeLimit = 100 * 1024 * 1024;

/** shopee 视频资源域名 */
export const shopeeVideoDomains = [
  'down-cvs-br.vod.susercontent.com',
  'down-tx-sg.vod.susercontent.com',
  'down-ws-sg.vod.susercontent.com',
  'down-bs-sg.vod.susercontent.com',
  'down-zl-br.vod.susercontent.com',
  'down-tx-br.vod.susercontent.com',
  'down-cvs-sg.vod.susercontent.com',
  'down-tx-global.vod.susercontent.com',
  'down-ws-br.vod.susercontent.com',
  'down-ws-global.vod.susercontent.com',
  'down-bs-br.vod.susercontent.com',
  'down-zl-sg.vod.susercontent.com',
];

/** 评价模块平台映射 */
export const reviewChannelMap = {
  1: 'SHOPEE',
  2: 'LAZADA',
  3: 'MERCADO',
  4: 'TIKTOK',
  5: 'TIKTOK_US',
} as const;
